import * as Logger from "../backend/TelemetryLogger/Details/Logger";
import { LogEventNames } from "../backend/interfaces/ITelemetryLogger";
import { FileUploadForegroundTaskError, FileUploadForegroundTaskErrors } from '../backend/FileUploadForegroundTaskErrors';
import { BootError, BootErrors } from "../frontend/BootErrors";
import { AudioBackupError, AudioBackupErrors } from "../backend/audioBackup/AudioBackupErrors";
import { ErrorStringFromException } from "../utils/utils";

/**
 * Main telemetry logging API for Errors
  * @param area Event area that error occured in
  * @param message Error string to be logged
 */
export function LogError(area: LogEventNames, message: string) {
    Logger.LogError({ area, message });
}

export function LogErrorAndThrow(area: LogEventNames, error) {
    LogError(area, ErrorStringFromException(error));
    throw error;
}

// If this returns true, we should log the error as warning
// so it does not affect our error metrics.
export function ShouldLogErrorAsWarning(error: Error) {
    // Track unsupported file format as a warning.  
   if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.UnsupportedFileFormat)
       return true;

    if (error instanceof BootError && error.name == BootErrors.IndexeddbFailedToOpen)
        return true;

    if (error instanceof AudioBackupError && error.name == AudioBackupErrors.UnsupportedBrowser)
        return true;

   return false;
}
